<mat-grid-list *ngIf="items" [cols]="cols" gutterSize="0">
  <mat-grid-tile *ngIf="loading">
    <mat-spinner diameter="150"></mat-spinner>
  </mat-grid-tile>
  <mat-grid-tile *ngIf="!loading && !(items && items.length)">
    <div class="no-image">
      <mat-icon>photo_camera</mat-icon>
      <div>No photo</div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile *ngFor="let item of items; index as i" [rowspan]="item.rowspan">
    <img [style.background-image]="bypassSecurity('url(' + item.dataUri + ')')" (click)="openImageDialog(i)">
  </mat-grid-tile>
</mat-grid-list>